<template>
    <div class="row">
        <div class="col-5">
            <ul class="list-group">
                <li class="list-group-item list-group-title">
                    <img :src="$Img.url + 'SPA/Icon-預約紀錄.png'" width="25px"></img>
                    {{ title }} <br>
                    <div style="color: grey;">{{ selectedDate }}</div>
                </li>
                <li class="list-group-item reserved-item" v-if="!listItems.length">
                    暫無預約
                </li>
                <li class="list-group-item reserved-item" v-for="(item, index) in listItems" :key="index">
                    <div class="d-flex" style="justify-content: space-between;">
                        <div>
                            <div class="purple-bar"></div>
                            {{ item }}
                        </div>
                        <div v-if="$route.path === '/SpaRecord'">
                            <button type="button" class="btn btn-danger" @click="cancel(item)">取消</button>
                        </div>

                    </div>
                </li>

                <li v-for="n in Math.max(10 - (listItems.length || 1), 0)" :key="`empty-${n}`" class="list-group-item">
                    &nbsp;
                </li>
            </ul>
        </div>
        <div class="col-7 cal">
            <vue-cal :events="events" :default-view="'month'" events-on-month-view="full" :locale="'zh-hk'"
                :disable-views="['years', 'year', 'week', 'day']" @cell-click="showList" @view-change="onViewChange">
                <template v-slot:event-render="{ event }">
                    <div class="custom-event">
                        {{ event.title }}
                    </div>
                </template>
            </vue-cal>
        </div>
    </div>

</template>

<script>
import { VueCal } from 'vue-cal'
import 'vue-cal/dist/vuecal.css';

export default {
    data() {
        return {
            selectedDate: new Date().toISOString().split('T')[0],
            listItems: [],
        }
    },
    props: {
        events: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    },
    methods: {
        onViewChange(view) {
            if (view.startDate) {
                const date = new Date(view.startDate);
                const selectedMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
                this.$emit('month-change', selectedMonth);
            }
        },
        showList(date) {
            if (!date) {
                console.warn("點擊的日期為 null，請檢查 VueCal 配置");
                return;
            }
            this.selectedDate = date.format('YYYY-MM-DD');

            const filteredEvents = this.events.filter((event) => {
                const eventDate = new Date(event.start).toLocaleDateString('en-CA');
                return eventDate === this.selectedDate;
            });

            this.listItems = filteredEvents.map((event) => {
                if (event.time) {
                    return event.time + ' ' + event.title;
                } else {
                    return event.title;
                }
            });
        },
        cancel(item) {
            this.$emit('cancel', { date: this.selectedDate, item });
        }
    },
}
</script>

<style scoped>
.cal /deep/ .vuecal__event-title {
    color: #AB65CC;
    font-size: 1rem !important;
    font-weight: bold;
}

.cal /deep/ .vuecal__cell-content {
    width: 30px;
    height: 100px;
    justify-content: flex-start !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>

<style>
.vuecal__menu {
    display: none !important;
}

.vuecal__cell-date {
    font-size: 1.5rem;
    color: #E27814;
    font-weight: 600;
}

.vuecal__cell--out-of-scope .vuecal__cell-date {
    color: #ccc;
}

.vuecal__event-time {
    display: none;
}

.weekday-label {
    color: #E27814;
}

.vuecal__title-bar {
    background-color: #E0D2D2;
}

.vuecal__title button {
    pointer-events: none;
}

.reserved-item {
    color: #AB65CC;
    font-weight: bold;
}

.list-group-item {
    text-align: left;
    font-size: 1.5rem;
}

.purple-bar {
    width: 5px;
    height: 20px;
    background-color: #AB65CC;
    display: inline-block;
}

.vuecal__cell,
.weekday-label {
    background-color: white;
}

.list-group-title {
    font-size: 1rem;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/Mymodule/Calendar.vue